<div class="users-management-content">
  <!-- Header -->
  <div class="header">
    <div class="title">User management</div>
    <div class="description">Manage your team members and their project permissions here</div>
  </div>
  <!-- Search -->
  <div class="users-search">
    <div class="title">All users</div>
    <div class="search"></div>
     @if (account?.role === 'admin') {
      @if (canManageTeams) {
        <div class="button secondary" (click)="createTeam()">Add Team</div>
      }
      <div class="button" (click)="inviteUser()">Invite user</div>
    }
  </div>
  <!-- Teams -->
  <div class="teams">
    @for (team of teamUsers; track team) {
      <div class="team">
        <!-- Team -->
        <div class="team-name">{{ team.team?.name }}</div>
        <!-- Team Actions -->
        @if (account?.role === 'admin') {
          <div class="button-icon team-menu" [matMenuTriggerFor]="teamMenu">
            <mat-icon svgIcon="dots" class="icon"></mat-icon>
          </div>
          <mat-menu #teamMenu="matMenu">
            <ng-template matMenuContent>
              <button mat-menu-item (click)="editTeam(team)">Edit Team</button>
              @if (canManageTeams && !(team.team?.permissions | includesBy: 'admin:all')) {
                <button mat-menu-item (click)="deleteTeam(team)" style="color: red;">Delete Team</button>
              }
            </ng-template>
          </mat-menu>
        }
        <!-- Users -->
        <div class="users">
          @for (user of team.users; track user.id) {
            <div class="user">
              <div class="photo">
                @if (user.photoUrl?.length) {
                  <img class="image" [src]="user.photoUrl">
                }
              </div>
              <div class="info">
                <div class="name">{{ user.name }}</div>
                <div class="email">
                  <div class="text">{{ user.email }}</div>
                  @if (user.status === 'pending') {
                    <div class="status">Invited</div>
                  }
                </div>
              </div>
              <div class="role" [ngClass]="user.role" [class.disabledMenu]="account?.role !== 'admin'" [matMenuTriggerFor]="roleMenu" [matMenuTriggerData]="{user: user}">{{ user.role }}</div>
              @if (account?.role === 'admin') {
                <div class="actions">
                  <div class="delete" [class.disabled]="account?.email === user.email">
                    <mat-icon svgIcon="trash" class="icon" (click)="deleteUser(user)"></mat-icon>
                  </div>
                  <!-- @if (user.status === 'pending') { -->
                    <div class="copy" [class.disabled]="account?.email === user.email">
                      @if (user.status === 'pending') {
                        <mat-icon svgIcon="copy-link" class="icon" (click)="regenerateToken(user)"></mat-icon>
                      }
                      @else {
                        <mat-icon svgIcon="copy-link" class="icon" (click)="resetPassword(user)"></mat-icon>
                      }
                    </div>
                  <!-- } -->
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
  <mat-menu #roleMenu="matMenu" xPosition="before" yPosition="above">
    <ng-template matMenuContent let-user="user">
      <button mat-menu-item (click)="changeRole(user, 'admin')">admin</button>
      <button mat-menu-item (click)="changeRole(user, 'user')">user</button>
    </ng-template>
  </mat-menu>
</div>